<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <div class="container">
    <a class="navbar-brand" href="#">
      <img src="../../../assets/images/logo/septa.png" height="30" class="d-inline-block align-top" alt="SEPTA Logo">
      SEPTA | Real-time
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText"
      aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarText">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a class="nav-link" routerLink="/" [routerLinkActive]="['active']"
            [routerLinkActiveOptions]="{exact:true}">Home<span class="sr-only" routerLink="/"
              [routerLinkActive]="['active-sr']"></span></a>
        </li>
        <li class="nav-item">
          <nav>
            <a class="nav-link" routerLink="/system" [routerLinkActive]="['active']">System Status<span class="sr-only"
                routerLink="/system" [routerLinkActive]="['active-sr']"></span></a>
          </nav>
        </li>
        <li class="nav-item">
          <nav>
            <a class="nav-link" routerLink="/train" [routerLinkActive]="['active']">TrainView<span class="sr-only"
                routerLink="/train" [routerLinkActive]="['active-sr']"></span></a>
          </nav>
        </li>
        <li class="nav-item">
          <nav>
            <a class="nav-link" routerLink="/map" [routerLinkActive]="['active']">TransitView<span class="sr-only"
                routerLink="/map" [routerLinkActive]="['active-sr']"></span></a>
          </nav>
        </li>
        <!--
            <li class="nav-item">
                <nav>
                    <a class="nav-link" routerLink="/nta">Next to Arrive</a>
                </nav>
            </li> 
         -->
        <li class="nav-item">
          <nav>
            <a class="nav-link" routerLink="/schedules" [routerLinkActive]="['active']">Schedules</a>
          </nav>
        </li>
      </ul>
    </div>
  </div>
</nav>

<div class="container mt-3">
  <div class="row">
      <div class="col-sm-12">

        <div class="alert alert-primary" role="alert">
          We are previewing our <a href="https://beta-realtime.septa.org/">new website here</a>.
        </div>
      </div>
  </div>
</div>